import React, {useEffect, useState, useContext} from "react";
import {useHistory} from "react-router-dom";
import styles from "./sideBar/SideBar.module.scss"
import ProcessMapViews from "./sideBar/ProcessMapViews";
import Filters from "./sideBar/Filters";
import BpmnModel from "./sideBar/BpmnModel";
import HelpInfoBox from "../../Componnets/HelpInfoBox/HelpInfoBox";
import appContext from "../../../context/appContext";

const filters = <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fillRule="evenodd" clipRule="evenodd"
        d="M7.51885 19.1667L11.8971 17.1059V11.7053L18.7627 4.74251C19.0214 4.48162 19.1666 4.12355 19.1666 3.74858V2.22441C19.1666 1.45546 18.5632 0.833328 17.8187 0.833328H2.18126C1.43672 0.833328 0.833313 1.45546 0.833313 2.22441V3.78343C0.833313 4.13728 0.963199 4.47739 1.1974 4.73512L7.51885 11.7053V19.1667Z"
        stroke="#0A195C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>;

const views = <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M9.2741 16.4877H2.64282" stroke="#0A195C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  <path fillRule="evenodd" clipRule="evenodd"
        d="M19.3581 16.4877C19.3581 17.9458 18.1761 19.1277 16.7181 19.1277C15.26 19.1277 14.0781 17.9458 14.0781 16.4877C14.0781 15.0286 15.26 13.8477 16.7181 13.8477C18.1761 13.8477 19.3581 15.0286 19.3581 16.4877Z"
        stroke="#0A195C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  <path d="M12.7258 5.74028H19.3582" stroke="#0A195C" strokeWidth="1.5" strokeLinecap="round"
        strokeLinejoin="round"/>
  <path fillRule="evenodd" clipRule="evenodd"
        d="M2.6424 5.74028C2.6424 7.1994 3.82436 8.38028 5.2824 8.38028C6.74043 8.38028 7.9224 7.1994 7.9224 5.74028C7.9224 4.28224 6.74043 3.10028 5.2824 3.10028C3.82436 3.10028 2.6424 4.28224 2.6424 5.74028Z"
        stroke="#0A195C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>;

const bpmn = <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fillRule="evenodd" clipRule="evenodd"
        d="M13.5087 2.53174H7.41007C5.52265 2.53174 3.89557 4.06166 3.89557 5.94999V15.7702C3.89557 17.7649 5.41632 19.3553 7.41007 19.3553H14.7333C16.6217 19.3553 18.1516 17.6595 18.1516 15.7702V7.36807L13.5087 2.53174Z"
        stroke="#0A195C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  <path
    d="M13.2678 2.52101V5.18759C13.2678 6.48926 14.3211 7.54526 15.6218 7.54801C16.8291 7.55076 18.0638 7.55168 18.1472 7.54618"
    stroke="#0A195C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  <path d="M13.0937 14.2613H8.14642" stroke="#0A195C" strokeWidth="1.5" strokeLinecap="round"
        strokeLinejoin="round"/>
  <path d="M11.2223 9.72179H8.146" stroke="#0A195C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>;

const arrowRight = <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M1.66666 10.6667L6.33332 6L1.66666 1.33333" stroke="#200E32" strokeWidth="1.5" strokeLinecap="round"
        strokeLinejoin="round"/>
</svg>;

const SideBar = ({sidebarItems, mode = ''}) => {

  const [hoverActiveFilters, setHoverActiveFilters] = React.useState(false)

  const context = useContext(appContext);
  const history = useHistory();

  const [activeItemIndex, setActiveItemIndex] = useState({});

  const handleItemActiveIndex = (index) => {
    setActiveItemIndex(prevState => ({[index]: !prevState[index]}))
    context.dispatch({type: 'set_item_active_index', value: index});
    if (activeItemIndex["activeFilters"]) {
      setHoverActiveFilters(false)
    }
  }

  useEffect(() => {
    if (activeItemIndex['filters']) {
      document.querySelector("body").style.overflow = "hidden";
      context.handleIsFiltersModalOpen(true)
    } else if (activeItemIndex['activeFilters']) {
      context.handleIsFiltersModalOpen(true)
    } else {
      document.querySelector("body").style.overflow = "inherit";
      context.handleIsFiltersModalOpen(false)
      context.handleIsClickedOnLayerSelection(false)
    }
  }, [activeItemIndex])

  let sideBarData = {
    filters: <li key={"filters"} className={mode === 'sideBySide' ? styles.sideBySide : ''}>
      {
        (history.location && (history.location.pathname !== "/process-compare" || !activeItemIndex['filters'])) &&
          <div onClick={() => {
            handleItemActiveIndex('filters')
            setHoverActiveFilters(false)}
          }
               onMouseEnter={() => context.handleHasSavedFilters() && !activeItemIndex['filters'] ? setHoverActiveFilters(true) : null}
               onMouseLeave={() => context.handleHasSavedFilters() ? setHoverActiveFilters(false) : null}
               className={[(activeItemIndex['filters'] || context.handleHasSavedFilters()) ? styles.active : '', styles.item].join(' ')}>
          <span>
            <i>{filters}</i>
            <span>Filters</span>
            <i className={styles.arrow}>
              {arrowRight}
            </i>
          </span>
          </div>
      }
      {
        history.location && history.location.pathname === "/process-compare" && (!localStorage.getItem("meetAnalysis") || !JSON.parse(localStorage.getItem("meetAnalysis")).includes(context.handleUid().id)) &&
          <div className={styles.helpInfoBox}>
            <HelpInfoBox direction={"right"}>
              <p>
                Filtering just affects the <span>main layer</span> and <span>current analysis.</span> In case
                you wanted to change other layer's Filters please use "Go to Analysis" option in Layer Panel.
              </p>
            </HelpInfoBox>
          </div>
      }
      {
        context.handleHasSavedFilters() && history.location.pathname !== "/process-compare" &&
          <div
            onMouseEnter={() => context.handleHasSavedFilters() ? !activeItemIndex['filters'] && setHoverActiveFilters(true) : null}
            onMouseLeave={() => (context.handleHasSavedFilters() && !activeItemIndex["activeFilters"]) ? setHoverActiveFilters(false) : null}
            onClick={() => {
              handleItemActiveIndex('activeFilters')
              setHoverActiveFilters(true)
            }} className={`${styles.activeFilters} ${hoverActiveFilters && styles.hover}`}>
            <div>Active Filters</div>
            <div>
              <i className={styles.arrow}>
                {arrowRight}
              </i>
            </div>
          </div>
      }
      <Filters mode={mode} showModal={activeItemIndex['filters']} showActiveFiltersPopup={activeItemIndex['activeFilters']} handleTriggerShowModal={handleItemActiveIndex}/>
    </li>,
    views: <li key={"views"}>
      {
        (history.location && (history.location.pathname !== "/process-compare" || !activeItemIndex['filters'])) &&
          <div onClick={() => handleItemActiveIndex('views')}
               className={[(activeItemIndex['views']) ? styles.active : '', styles.item].join(' ')}>
          <span>
            <i>{views}</i>
            <span>Views</span>
            <i className={styles.arrow}>
              {arrowRight}
            </i>
          </span>
          </div>
      }
      <ProcessMapViews showModal={activeItemIndex['views']} handleTriggerShowModal={handleItemActiveIndex}/>
    </li>,
    bpmnModel: <li key={"bpmnModel"}>
      <div onClick={() => handleItemActiveIndex('bpmn')}
           className={[(activeItemIndex['bpmnModel']) ? styles.active : '', styles.item].join(' ')}>
        <span>
          <i>{bpmn}</i>
          <span>BPMN Model</span>
          <i className={styles.arrow}>
            {arrowRight}
          </i>
        </span>
      </div>
      <BpmnModel showModal={activeItemIndex['bpmn']} handleTriggerShowModal={handleItemActiveIndex}/>
    </li>
  }

  if (mode === 'sideBySide') {
    sideBarData = {views: sideBarData.views, bpmnModel: sideBarData.bpmnModel, filters: sideBarData.filters}
  }

  return (
    <div id={"mainSidebar"} className={styles.SideBar}>
      <ul className={mode === 'sideBySide' ? styles.sideBySide : null}>
        {
          Object.entries(sideBarData).map(([key, value]) => (
            sidebarItems.some(i => i === key) &&
            value
          ))
        }
      </ul>
    </div>
  )
};

export default SideBar;
